import { useQueryClient } from '@tanstack/react-query';
import useMutationApi from '../useMutationApi';

interface ReopenAgreementResponse {
  success: boolean;
  message: string;
  data: {
    id: string;
    isClosedOut: boolean;
    closureMetadata: null;
  };
}

/**
 * Hook to reopen a closed rebate agreement
 */
const useReopenRebateAgreement = (agreementId: string) => {
  const queryClient = useQueryClient();

  return useMutationApi<void, ReopenAgreementResponse>({
    endpoint: `rebates/agreements/${agreementId}/reopen`,
    method: 'POST',
    options: {
      onSuccess: () => {
        // Invalidate rebate agreements queries to refresh the data
        queryClient.invalidateQueries({
          queryKey: ['rebates/agreements'],
        });
        queryClient.invalidateQueries({
          queryKey: [`rebates/agreements/${agreementId}`],
        });
      },
    },
    successMessage: 'Agreement reopened successfully',
  });
};

export default useReopenRebateAgreement;
